exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-header {\n\tborder-bottom: 1px solid #eaeefb;\n\tmargin-bottom: 1em;\n\tpadding-bottom: 0.5em;\n}\n.custom-title {\n\tmargin: 0;\n\tpadding-top: 0.25em;\n}\n", ""]);

// exports
